import * as React from 'react';
import { Link } from 'react-router-dom';
import { UitkHeading } from 'uitk-react-text';

export interface RoomComponentPackageDesktopProps {
  roomCount: any;
  childComponent: any;
}
export class RoomComponentPackageDesktop extends React.Component<RoomComponentPackageDesktopProps, any> {
  public constructor(props) {
    super(props);
  }

  public render() {
    const { roomCount } = this.props;

    return (
      <>
        <div className="uitk-cell" />
        <div className="uitk-cell" />
        <div className="uitk-cell all-b-margin-four">{this.props.childComponent}</div>
        <div className="uitk-cell" />
      </>
    );
  }
}
